import { Flex, Text, Menu, MenuButton, MenuList, Divider, Tooltip } from '@chakra-ui/react';
import React, { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ChevronDownIcon } from '@chakra-ui/icons';

import FigmaFilterIcon from 'components/Icons/FigmaFilterIcon';
import {
  getDashboardBlocks,
  //   getSelectedDashboardScenario,
  //   createInstrument,
  //   updateInstrument,
  //   setEditInstrumentOutput,
  //   setEditInstrumentData,
} from 'redux/DashboardSliceV2';

// import PreviewSelectCheckBox from '../../../components/PreviewFilterCheckBox';
// import PreviewSelectCheckBox from 'components/PreviewFilterCheckBox/MultiSelectCheckBox';

import { findDimensionItems } from './Filters';
import PreviewSelectCheckBox from './MultiSelectCheckBox';

interface Properties {
  widget: any;
  handleApplyFilter: any;
}

const PriviewFilterByComponent = ({ widget, handleApplyFilter }: Properties) => {
  //   const dispatch: any = useDispatch();
  //   const selectedDashboardScenario = useSelector(getSelectedDashboardScenario);
  const blockDetails = useSelector(getDashboardBlocks);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [filterItem, setFilterItem] = useState<any>([]);

  useEffect(() => {
    const data = findDimensionItems(widget, blockDetails);
    setFilterItem(data);
  }, [widget?.instrument_indicators, blockDetails]);
  //   const processedDimensionsData = useMemo(
  //     () =>
  //       widget?.instrument_indicators.map(({ block_id, indicator_id }: any) => {
  //         const foundBlock = blockDetails.find((block: any) => block.block_id === block_id);
  //         const foundIndicator = foundBlock?.indicators?.find(
  //           (indicator: any) => indicator.id === indicator_id,
  //         );
  //         return {
  //           blockid: block_id,
  //           indicatorid: indicator_id,
  //           dimension: foundIndicator?.indicator_dimensions || [],
  //         };
  //       }),
  //     [widget?.instrument_indicators, blockDetails],
  //   );
  const processedDimensionsData = useMemo(() => {
    return widget?.instrument_indicators
      .map(({ block_id, indicator_id, dimension_id }: any) => {
        const foundBlock = blockDetails.find((block: any) => block.block_id === block_id);
        const foundIndicator = foundBlock?.indicators?.find(
          (indicator: any) => indicator.id === indicator_id,
        );
        return {
          blockid: block_id,
          indicatorid: indicator_id,
          dimension:
            foundIndicator?.indicator_dimensions?.filter(
              (dim: any) => dimension_id && dim.indicator_dimension_id === Number(dimension_id),
            ) || [],
        };
      })
      .filter((item: any) => item.dimension.length > 0); // Filter out objects with empty dimension arrays
  }, [widget?.instrument_indicators, blockDetails]);

  const handleApplyFilterFunction = (filterAppliedData: any) => {
    handleApplyFilter(filterAppliedData, filterItem);
    setIsMenuOpen(false);
  };

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  //   const handleOpenMenu = () => {
  //     setIsMenuOpen(true);
  //   };

  const renderTooltipContent = () => {
    if (widget?.instrument_type === 'kpi') {
      return (
        <Flex alignItems='center' flexWrap='wrap' maxW='100%' gap={2}>
          <Text size={'Roboto-12'} flexShrink={0}>
            Filter By:
          </Text>
          <Divider
            mx={2}
            orientation='vertical'
            size='2xs'
            sx={{
              borderColor: '#706B9A',
            }}
            height='12px'
            alignSelf='center'
            flexShrink={0}
          />
          <Text size='Roboto-12'>All items</Text>
        </Flex>
      );
    }

    return (
      <Flex alignItems='center' gap={2} flexWrap='wrap' maxW='100%' rowGap={1}>
        <Text size={'Roboto-12'} flexShrink={0}>
          Filter By:
        </Text>
        {filterItem &&
          filterItem[0]?.dimensionItems?.map((item: any, index: number) => (
            <React.Fragment key={index}>
              {item && (
                <Flex alignItems='center' key={index} flexShrink={0} maxW='100%'>
                  <Divider
                    mx={2}
                    orientation='vertical'
                    size='2xs'
                    sx={{
                      borderColor: '#706B9A',
                    }}
                    height='12px'
                    alignSelf='center'
                    flexShrink={0}
                  />
                  <Text size='Roboto-12' wordBreak='break-word'>
                    {item.dimensionItemName}
                  </Text>
                </Flex>
              )}
            </React.Fragment>
          ))}
      </Flex>
    );
  };

  return (
    // No variant — 'filter' is the shared old-theme menu variant (still relied
    // on by every un-revamped Plan/Dashboard-v2 filter popup), and its `list`
    // style is a hardcoded `border: 4px #4F71B5 solid` plus p:5. That thick
    // blue frame was the one piece of this popover the icon/search/checkbox
    // pass didn't touch. Styled directly on MenuList below instead, matching
    // this branch's other overlay (SelectionPopover.tsx).
    <Menu
      isOpen={isMenuOpen}
      onClose={() => setIsMenuOpen(false)}
      onOpen={() => setIsMenuOpen(true)}
      strategy='fixed'
      direction={'ltr'}
    >
      <Tooltip
        label={renderTooltipContent()}
        placement='auto-start'
        hasArrow
        maxW='600px'
        bg='white'
        color='black'
        p={4}
        borderRadius='sm'
        boxShadow='0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.1)'
        openDelay={100}
        sx={{
          whiteSpace: 'normal',
          '--popper-arrow-bg': 'white',
          '--tooltip-bg': 'white',
          '--tooltip-color': 'black',
          '--tooltip-padding': '1rem',
          '--tooltip-border-radius': '0.5rem',
          '--tooltip-shadow':
            '0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.1)',
          '--tooltip-arrow-shadow': '0 4px 6px -1px rgba(0, 0, 0, 0.2)',
          '--tooltip-arrow-size': '8px',
          '--tooltip-arrow-offset': '4px',
        }}
      >
        <MenuButton>
          {/* Was a bare BiFilter (react-icons) at 35px in a mismatched teal
              (#4BB6B9), sitting on a flat grey blob with no border — visibly a
              different design language from every other control on the card.
              FigmaFilterIcon is the same asset the Dimensions table filter
              chip already uses; this now matches that chip's neutral
              border/pill shape instead of inventing its own. */}
          <Flex
            alignItems='center'
            gap='6px'
            bg='white'
            border='1px solid #D1D6DD'
            borderRadius='8px'
            px='10px'
            py='6px'
            cursor='pointer'
            role='button'
            tabIndex={0}
            title='Filter By'
            transition='background 0.12s ease, border-color 0.12s ease'
            _hover={{ bg: '#F5F0FF', borderColor: '#C4B5FD' }}
          >
            <FigmaFilterIcon width={13} height={13} color='#708090' />
            <Text fontSize='12px' fontWeight='500' color='#121826'>
              {filterItem[0]?.dimensionItems?.length}
            </Text>
            <ChevronDownIcon fontSize='sm' color='#708090' />
          </Flex>
        </MenuButton>
      </Tooltip>
      {/* {isOpen && ( */}
      <MenuList
        bg='white'
        border='1px solid #D1D6DD'
        borderRadius='14px'
        boxShadow='0px 8px 24px rgba(18, 24, 38, 0.16)'
        p='16px'
        minWidth='unset'
      >
        <Flex gap={8} maxW={'600px'} overflowX={'auto'} className='sm-scroll'>
          {processedDimensionsData &&
            processedDimensionsData.length > 0 &&
            [processedDimensionsData[0]]?.map((checkBoxItem: any, index: number) => (
              <React.Fragment key={index}>
                <PreviewSelectCheckBox
                  handleApply={handleApplyFilterFunction}
                  handleClose={handleCloseMenu}
                  checkboxData={checkBoxItem}
                  isMenuOpen={isMenuOpen}
                  filterItem={filterItem}
                />
              </React.Fragment>
            ))}
        </Flex>
      </MenuList>
    </Menu>
  );
};

export default PriviewFilterByComponent;
